import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import { setUpdateDigitalLike } from "../../../../store/assessments-actions.js";
import { getClassByNum } from "../../../../utils/utils.js";
import { deviceTypes } from "../../../../enums/deviceTypes.js";
import { filtersSelectsData } from "../../filters/FiltersData.js";
import Icon from "../../../ui/icons/Icon.js";
import Tooltip from "../../../ui/tooltip/Tooltip.js";
import iconsList from "../../../ui/icons/iconsList.js";
import defaultImage from "../../../../assests/digitalCuratorship/default.jpg"
import studentApproved from "../../../../assests/digitalCuratorship/studentApproved.png"
import classes from "./DigitalCuratorshipItem.module.css";

const DigitalCuratorshipItem = ({ challengeId, desktopImage, mobileImage, link, name, description, likeCount, shares, viewCount, isView, isLike, maxScore, fromClass, toClass, skillz, score, type, isBig, handleOnClick, isStudentApproved, filterAIComp, filterContentType }) => {

    const { texts } = useSelector(state => state.translate);
    const { isStudent } = useSelector((state) => state.auth);
    const { deviceType } = useSelector(state => state.responsive);
    const dispatch = useDispatch()
    const image = deviceType === deviceTypes.mobile ? mobileImage : desktopImage;

    const handleLikeClick = (e) => {
        e && e.stopPropagation()
        dispatch(setUpdateDigitalLike(challengeId))
    }

    const getOptionName = (filter, value) =>
        filter?.options.find(opt => Array.isArray(opt.value) ? opt.value.includes(value) : opt.value === value)?.name;

    return (
        <div className={classes.CardWrapper}>
            <AccessibilityClickableDiv onClick={() => handleOnClick(challengeId, type, link, skillz)}>
                <div className={`${classes.Card} ${isBig ? '' : deviceType !== deviceTypes.mobile ? classes.SmallCard : classes.MobileSmallCard}`} style={isBig || deviceType !== deviceTypes.mobile ? { backgroundImage: `url(${image || defaultImage})` } : {}}>
                    <AccessibilityHiddenImg src={image || defaultImage} />
                    {/* {isStudent ? */}
                    {/* // !score ?
                        //     <div className={classes.StarsWrapper} aria-label={`${texts.pointsWillAdded} ${maxScore}`}>
                        //         <Tooltip text={texts.pointsWillAdded} showTooltip={true}>
                        //             <div className={classes.Stars}>{maxScore}+</div>
                        //         </Tooltip>
                        //     </div>
                        //     : ''
                        : */}
                    {!isStudent && <div className={classes.TeacherInfo}>
                        {fromClass && toClass && <div className={classes.ClassesRange}>{`${getClassByNum(fromClass)}' - ${getClassByNum(toClass)}'`}</div>}
                        {filterContentType && (
                            <div className={classes.TagContentType}>
                                {texts[getOptionName(filtersSelectsData.find(f => f.filterName === "filterContentType"), filterContentType)]}
                            </div>
                        )}
                        {filterAIComp && filterAIComp.map((aiComp, index) => (
                            <div key={index} className={classes.TagAiComp}>
                                {texts[getOptionName(filtersSelectsData.find(f => f.filterName === "filterAIComp"), aiComp)]}
                            </div>
                        ))}
                        {(isStudentApproved && window.config.isStudentApprovedOption) &&
                            <Tooltip text={texts.studentApproved} showTooltip={true}>
                                <img alt={texts.studentApproved} className={classes.studentApproved} src={studentApproved} />
                            </Tooltip>
                        }
                    </div>
                    }
                    <div className={classes.Title}>{name}</div>
                    <div className={classes.Footer}>
                        <div className={classes.Subtitle}>{description}</div>
                    </div >
                </div >
            </AccessibilityClickableDiv>
            <div className={`${classes.Points} ${!isBig && deviceType === deviceTypes.mobile ? classes.MobileSmallCardPoints : ''}`}>
                <div className={classes.Views} aria-label={`${viewCount ?? 0} ${texts.views}`}>
                    <Icon size="19px" className={`${classes.Icon} ${isView && classes.IconColor}`} name={iconsList.eye} />
                    <span>{viewCount ?? 0}</span>
                </div>
                <div className={classes.Loves} aria-label={`${likeCount ?? 0} ${texts.like}`}>
                    <AccessibilityClickableDiv onClick={(e) => handleLikeClick(e)} accessibilityDescription={texts.like} className={classes.LoveIconWrapper}>
                        <Icon size="19px" className={`${classes.Icon} ${isLike && classes.IconColor}`} name={iconsList.like} onClick={(e) => handleLikeClick(e)} />
                    </AccessibilityClickableDiv>
                    <span>{likeCount ?? 0}</span>
                </div >
            </div >
        </div>
    );
};

export default DigitalCuratorshipItem;
